<template>
 
 <BContainer class="container-pages" v-if="adItem">
    <BRow>
      <BCol xl="9">
        <BRow>
          <BCol xl="4" lg="4" class="d-xl-block d-lg-block d-md-none d-sm-none d-none" >
            <div class="p-element-page shadow bg-white rounded" v-if="items.data.categories">
             <FilterCategory :categories="categories" :active="adItem?.category_name"></FilterCategory>
           </div>
          </BCol>
          <BCol xl="8" lg="8" v-if="adItem">
            <div class="p-element-page shadow bg-white rounded">
              <TitleSingle :advertisement="adItem"></TitleSingle>
              <ButtonSingle :advertisement="adItem"></ButtonSingle>
              <ImageSingleMobile :images="adItem?.images" :alt="imageAlt" v-if="!$screen.isDesktop"></ImageSingleMobile>
              <PriceSingle :advertisement="adItem"></PriceSingle>
             <div class="a-container mt-3 mb-3" v-if="$screen.showMobileAds">
               <AdsSingleMobile></AdsSingleMobile>            
             </div>
             <GeneralDataSingle :advertisement="items?.data?.ad"></GeneralDataSingle>
             <DescriptionSingle :advertisement="items?.data?.ad"></DescriptionSingle>
             <ImagesDesktop v-if="$screen.isDesktop && adItem?.images.length > 0"
                      :images="adItem?.images"
                      :alt="imageAlt"
                      ></ImagesDesktop>
               <div class="a-container mt-3 mb-3" v-if="$screen.isProduction">
                    <AdsSingleCenter></AdsSingleCenter>              
               </div>

            </div>
            <FaqCard v-if="faqs?.faq" :faq="faqs.faq" class="mt-2"></FaqCard>
          </BCol>
          <!-- <BCol xl="12" lg="12" v-if="detailsItem">
            <div class="p-element-page shadow bg-white rounded mt-2" style=" overflow-x: auto;">
                  <TableDisplay    
                               :table_fields="detailsItem.items[0].table.map"
                               :items_table="detailsItem.items[0].table.markets"
                               :rate="detailsItem.exchange"
                               :lang="lang"
                           >
                </TableDisplay>
              </div>
          </BCol> -->
        </BRow>
       
      </BCol>
      <BCol xl="3" lg="12" md="12">
        <div class="a-container mt-3 mb-3" v-if="$screen.showDesktopAds">
               <AdsBottomPage></AdsBottomPage>              
          </div>
          <FollowCard v-if="suggestions" :customer="suggestions" class="h-auto mb-3"></FollowCard>
          <TopAdsPages
          class="mt-3"
          v-if="topAds"
          :items="topAds"
          :category_name="''"
          :display_img="true"
        />

     </BCol>
     <BCol  class="d-xl-none d-lg-none d-md-block d-sm-block d-block mt-2" v-if="!$screen.isDesktop">
            <div class="p-element-page shadow bg-white rounded">
             <FilterCategory :categories="categories" :active="adItem?.category_name" :limit="8"></FilterCategory>
           </div>
      </BCol>
    </BRow>
  
  </BContainer>
</template>

<script setup>
import { BContainer, BRow, BCol } from 'bootstrap-vue-next';


import TitleSingle from '~/components/cmsCustomer/advertisement/display-single/TitleSingle';
import ButtonSingle from '~/components/cmsCustomer/advertisement/display-single/ButtonSingle.vue';
import ImageSingleMobile from '~/components/cmsCustomer/advertisement/display-single/ImageSingleMobile';
import PriceSingle from '~/components/cmsCustomer/advertisement/display-single/PriceSingle.vue';
import GeneralDataSingle from '~/components/cmsCustomer/advertisement/display-single/GeneralDataSingle.vue';
import DescriptionSingle from '~/components/cmsCustomer/advertisement/display-single/DescriptionSingle.vue';
import ImagesDesktop from '~/components/cmsCustomer/advertisement/display-single/ImagesDesktop.vue';
import TableDisplay from '~/components/widgets/DisplayTable/Table.vue';
import TopAdsPages from '~/components/widgets/Advertisement/TopAdsPages.vue'
import FaqCard from '~/components/widgets/Advertisement/FaqCard.vue';
import FilterCategory from '~/components/cmsCustomer/advertisement/filter/FilterCategory.vue';
import FollowCard from '~/components/widgets/Follow/FollowCard.vue';
const AdsBottomPage = defineAsyncComponent(() =>
  import('~/components/GoogleAdvertisements/AdsBottomPage.vue')
)

 const AdsSingleCenter = defineAsyncComponent(() =>
  import('~/components/GoogleAdvertisements/AdsSingleCenter.vue')
)

 const AdsSingleMobile = defineAsyncComponent(() =>
  import('~/components/GoogleAdvertisements/AdsSingleMobile.vue')
)
import { useShareMetaStore } from "~/stores/shareMeta";
const shareMeta = useShareMetaStore();

const config = useRuntimeConfig()
const { $srbTolat } = useNuxtApp()

const route = useRoute();

 

const locale = ref('sr')
const lang = computed(() =>  locale.value)
import { useCustomerItemsStore } from "~/stores/customer/items";
import TopAdsNew from '~/components/widgets/Advertisement/TopAdsNew.vue';
  
const useItemsStore = useCustomerItemsStore();

const idParam = computed(() => route.params.id)

// kad se udje na oglas (ili predje sa jednog oglasa na drugi) - skrol na vrh
const scrollToTop = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo(0, 0)
  }
}

onMounted(scrollToTop)
watch(idParam, scrollToTop)

const { data: items, error  } =  await useAsyncData(
  () => `ad-${route.fullPath}`,
  async () => useItemsStore.getCustomerItemsDetails({id: idParam.value}),
 {
    watch: [() => route.fullPath]
  }
);
 
 const categories = computed(() => items.value?.data?.categories ?? [])

const adItem = computed(() => items.value?.data?.ad ?? null)

//const detailsItem = computed(() => items.value?.data?.details ?? null)

const detailsItem = computed(() => null ?? null)


const suggestions = computed(() => items.value?.data?.suggestions ?? null)

const topAds = computed(() => items.value?.data?.top_ads ?? null)

const faqs = computed(() => items.value?.data?.faqs ?? null)
 
// ===== SEO / Schema =====
const canonicalUrl = computed(() => `https://pijace.com${route.fullPath}`)

// tagovi se menjaju razmakom (ne praznim), da se redovi opisa ne slepe ("lukPakovanje")
const stripHtml = (html) => String(html ?? '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()

// slike u strukturiranim podacima moraju imati pun URL
const absUrl = (url) => {
  if (!url) return url
  try { return new URL(url, 'https://pijace.com').href } catch (e) { return url }
}

const createDescription = (text) => {
  try {
    
    if (!text) return 'Oglasi | Cene na pijacama'
    const plain = stripHtml(text)
    return plain.length > 140 ? plain.slice(0, 137) + '...' : plain
  } catch (e) {
    return 'Oglasi | Cene na pijacama'
  }
}

const { displayPrice, currencySymbol } = usePriceFormat()

// "Beli luk – 400 RSD, Sakule | Pijace.com": naslov, cena (ako je fiksna) i mesto
const headTitle = computed(() => {
  const ad = adItem.value
  if (!ad) return 'Oglas | Pijace.com'

  const title = String(ad.title ?? '').length > 45 ? String(ad.title).slice(0, 42).trimEnd() + '…' : String(ad.title ?? '')
  const price = hasPrice.value
    ? `${displayPrice(ad.price_type, ad.price)} ${currencySymbol(ad.price_type, ad.currency_code)}`.trim()
    : ''
  const place = ad.place_name ? String(ad.place_name) : ''

  const head = price
    ? `${title} – ${price}${place ? ', ' + place : ''}`
    : `${title}${place ? ' – ' + place : ''}`

  return `${head} | Pijace.com`
})

// opis slike oglasa (alt): "Beli luk – oglas, Sakule"
const imageAlt = computed(() => {
  const ad = adItem.value
  return ad ? `${ad.title} – oglas${ad.place_name ? ', ' + ad.place_name : ''}` : 'Oglas'
})

const headDescription = computed(() => createDescription(adItem.value?.description_meta ?? adItem.value?.description))

const ogImage = computed(() =>
  adItem.value?.images?.[0]?.small
    ?? adItem.value?.images?.[0]?.medium
    ?? null
)

// Da li oglas ima fiksnu cenu (znači može da se prikaže kao Product sa Offer-om)
const hasPrice = computed(() =>
  !!adItem.value?.price && adItem.value?.price_type !== 'agreement'
)

// JSON-LD: Product (sa Offer) ako ima cenu, inače Article
const adLd = computed(() => {
  const ad = adItem.value
  if (!ad) return null
 

  const allImages = (ad?.images?.length
    ? ad.images.map(image => image?.medium || image?.small || image?.image).filter(Boolean)
    : (ogImage.value ? [ogImage.value] : [])).map(absUrl)

  if (hasPrice.value) {
    return {
      '@context': 'https://schema.org',
      '@type': 'Product',
      '@id': `${canonicalUrl.value}#product`,
      name: ad.title,
      description: stripHtml(ad.description),
      image: allImages,
      category: [ad.category_name, ad.subcategory_name].filter(Boolean).join(' > '),
      url: canonicalUrl.value,
      sku: `oglas-${ad.id}`,
      inLanguage: 'sr',
      seller: {
        '@type': ad.lawyer ? 'Organization' : 'Person',
        name: ad.customer_name,
        ...(ad.place_name
          ? {
              address: {
                '@type': 'PostalAddress',
                addressLocality: ad.place_name,
                addressCountry: 'RS'
              }
            }
          : {})
      },
      offers: {
        '@type': 'Offer',
        url: canonicalUrl.value,
        price: String(ad.price),
        priceCurrency: ad.currency_code || 'RSD',
        availability: ad.status === 'published'
          ? 'https://schema.org/InStock'
          : 'https://schema.org/OutOfStock',
        itemCondition: 'https://schema.org/NewCondition',
        seller: {
          '@type': ad.lawyer ? 'Organization' : 'Person',
          name: ad.customer_name
        }
      }
    }
  }

  // Oglas bez fiksne cene (dogovor) — Article bolji nego prazna WebPage
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    '@id': `${canonicalUrl.value}#article`,
    headline: ad.title,
    description: stripHtml(ad.description),
    image: allImages,
    url: canonicalUrl.value,
    inLanguage: 'sr',
    ...(ad.created_at ? { datePublished: ad.created_at } : {}),
    ...(ad.updated_at ? { dateModified: ad.updated_at } : {}),
    author: {
      '@type': ad.lawyer ? 'Organization' : 'Person',
      name: ad.customer_name
    },
    publisher: {
      '@type': 'Organization',
      name: 'Pijace.com',
      url: 'https://pijace.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://pijace.com/images/pijace-60.png'
      }
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': canonicalUrl.value
    }
  }
})

// JSON-LD: BreadcrumbList — Pijace.com → Oglasi → kategorija → (potkategorija) → oglas
const breadcrumbLd = computed(() => {
  const ad = adItem.value
  if (!ad) return null

  const items = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Oglasi na pijaci',
      item: 'https://pijace.com/oglasi/svi-oglasi/1'
    }
  ]

  let position = 2

  if (ad.category_name) {
    items.push({
      '@type': 'ListItem',
      position: position++,
      name: ad.category_name,
      item: `https://pijace.com/oglasi/${$srbTolat.srbTolatPath(String(ad.category_name))}/1`
    })
  }

  if (ad.subcategory_name) {
    items.push({
      '@type': 'ListItem',
      position: position++,
      name: ad.subcategory_name,
      item: `https://pijace.com/oglasi/${$srbTolat.srbTolatPath(String(ad.category_name || ''))}/${$srbTolat.srbTolatPath(String(ad.subcategory_name))}/1`
    })
  }

  items.push({
    '@type': 'ListItem',
    position: position,
    name: ad.title,
    item: canonicalUrl.value
  })

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items
  }
})

// JSON-LD: FAQPage — emituje se SAMO kad API vrati FAQ za ovaj oglas.
// Admin može da doda custom FAQ kroz panel; ako ga nema, schema se ne
// generiše (bolje nego template-ovan generički FAQ na svim stranicama).
const faqSchema = computed(() => {
  let faq = faqs?.value?.faq

  if (typeof faq === 'string') {
    try {
      faq = JSON.parse(faq)
    } catch {
      return null
    }
  }

  if (!Array.isArray(faq) || !faq.length) {
    return null
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map(item => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer
      }
    }))
  }
})

watchEffect(() => {
  if (!adItem.value) return
  shareMeta.setMeta({
    title: headTitle.value,
    description: headDescription.value,
    url: canonicalUrl.value,
  })
})

usePijaceSeo({
  title: headTitle,
  description: headDescription,
  url: canonicalUrl,
  type: () => hasPrice.value ? 'product' : 'article',
  image: ogImage,
  jsonLd: () => [adLd.value, breadcrumbLd.value, faqSchema.value],
})

// robots (max-image-preview:large važno za oglase sa slikama — pomaže u SERP)
useHead(() => ({
  meta: [
    {
      name: 'robots',
      content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
    },
  ],
}))

</script>

<style>

</style>